module.exports = __webpack_public_path__ + "img/badge.af36b9bf.svg";